import type { Environment } from './types';

export function getEnvironment(): Environment {
  return window.AccessEvo?.mfeHost?.environment || 'dev';
}
